import { gradient } from '@mentimeter/sfinx-themes';

export const GradientBackground = gradient.background;
